import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51ae74b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "review w-full rounded-md p-7" }
const _hoisted_2 = { class: "relative flex flex-row w-full justify-between items-center px-5 pb-7" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute w-full flex justify-center top-0 left-0 uppercase" }, " Review & Bridge ", -1 /* HOISTED */))
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "mr-1 capitalize" }
const _hoisted_7 = { class: "opacity-50 cursor-pointer" }
const _hoisted_8 = { class: "mr-1 capitalize" }
const _hoisted_9 = { class: "opacity-50 cursor-pointer" }
const _hoisted_10 = { class: "flex flex-row items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "flex flex-row items-center transform" }
const _hoisted_14 = {
  href: "https://docs.nomad.xyz/token-bridge/how-to-bridge#completing-a-transfer-ethereum-destination-only",
  target: "_blank"
}
const _hoisted_15 = { class: "flex flex-row items-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_transfer_steps = _resolveComponent("transfer-steps")!
  const _component_protocol = _resolveComponent("protocol")!
  const _component_transfer_pending = _resolveComponent("transfer-pending")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_review_detail = _resolveComponent("review-detail")!
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_alert_circle = _resolveComponent("alert-circle")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_review_send = _resolveComponent("review-send")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" header "),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadcrumb, {
        onClick: _ctx.back,
        class: "z-10"
      }, null, 8 /* PROPS */, ["onClick"]),
      _hoisted_3,
      _createVNode(_component_transfer_steps, { current: 2 })
    ]),
    _createCommentVNode(" protocol select "),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_protocol, {
        selected: _ctx.protocol === 'nomad',
        name: "nomad",
        time: "35-60 min",
        description: "Bridges funds from one chain to another",
        fee: "No fee, just pay gas",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.protocol = 'nomad'))
      }, null, 8 /* PROPS */, ["selected"]),
      _createVNode(_component_protocol, {
        selected: _ctx.protocol === 'connext',
        name: "connext",
        time: "7-10 min",
        description: "Swaps existing liquidity between chains",
        fee: _ctx.connextAdditionalFee,
        onClick: _ctx.selectConnext
      }, null, 8 /* PROPS */, ["selected", "fee", "onClick"])
    ]),
    (_ctx.sending || _ctx.preparingSwap)
      ? (_openBlock(), _createBlock(_component_transfer_pending, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" transfer details "),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_review_detail, { title: "From" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userInput.originNetwork), 1 /* TEXT */),
                    _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, " | " + _toDisplayString(_ctx.truncateAddr(_ctx.walletAddress)), 1 /* TEXT */)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.walletAddress), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_review_detail, { title: "To" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userInput.destinationNetwork), 1 /* TEXT */),
                    _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("span", _hoisted_9, " | " + _toDisplayString(_ctx.truncateAddr(_ctx.userInput.destinationAddress || _ctx.walletAddress)), 1 /* TEXT */)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.userInput.destinationAddress || _ctx.walletAddress), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_review_detail, { title: "Send amount" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _ctx.userInput.token.icon,
                      class: "h-4 mr-1"
                    }, null, 8 /* PROPS */, _hoisted_11),
                    _createTextVNode(" " + _toDisplayString(_ctx.userInput.sendAmount) + " " + _toDisplayString(_ctx.userInput.token.symbol), 1 /* TEXT */)
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              (_ctx.protocol === 'nomad')
                ? (_openBlock(), _createBlock(_component_review_detail, {
                    key: 0,
                    title: "Gas Fee"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.originGasFee) + " GWEI (" + _toDisplayString(_ctx.nativeAssetSymbol(_ctx.userInput.originNetwork)) + ") ", 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.protocol === 'connext')
                ? (_openBlock(), _createBlock(_component_review_detail, {
                    key: 1,
                    title: "Tx Fees"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.connextFee)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.connextFee) + " " + _toDisplayString(_ctx.userInput.token.symbol), 1 /* TEXT */))
                        : (_openBlock(), _createBlock(_component_n_skeleton, {
                            key: 1,
                            width: 150,
                            height: 21,
                            round: "",
                            size: "small"
                          }))
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.protocol === 'nomad' && _ctx.requiresManualProcessing)
                ? (_openBlock(), _createBlock(_component_review_detail, {
                    key: 2,
                    title: "Processing Gas Fee"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createTextVNode(" Calculated on Processing (" + _toDisplayString(_ctx.nativeAssetSymbol(_ctx.userInput.destinationNetwork)) + ") ", 1 /* TEXT */),
                        _createElementVNode("a", _hoisted_14, [
                          _createVNode(_component_n_icon, {
                            size: "22",
                            color: "#70c0e8",
                            class: "ml-1 cursor-pointer translate-y-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_alert_circle)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.protocol === 'nomad')
                ? (_openBlock(), _createBlock(_component_review_detail, {
                    key: 3,
                    title: "Receive Amount",
                    borderBottom: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: _ctx.userInput.token.icon,
                          class: "h-4 mr-1"
                        }, null, 8 /* PROPS */, _hoisted_16),
                        _createTextVNode(" " + _toDisplayString(_ctx.userInput.sendAmount) + " " + _toDisplayString(_ctx.receiveAssetSymbol()), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.protocol === 'connext')
                ? (_openBlock(), _createBlock(_component_review_detail, {
                    key: 4,
                    title: "Est. Receive Amount",
                    borderBottom: false
                  }, {
                    default: _withCtx(() => [
                      (_ctx.connextFee)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("img", {
                              src: _ctx.userInput.token.icon,
                              class: "h-4 mr-1"
                            }, null, 8 /* PROPS */, _hoisted_18),
                            _createTextVNode(" " + _toDisplayString(_ctx.connextReceiveAmt()) + " " + _toDisplayString(_ctx.receiveAssetSymbol()), 1 /* TEXT */)
                          ]))
                        : (_openBlock(), _createBlock(_component_n_skeleton, {
                            key: 1,
                            width: 150,
                            height: 21,
                            round: "",
                            size: "small"
                          }))
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Send "),
            _createVNode(_component_review_send, { protocol: _ctx.protocol }, null, 8 /* PROPS */, ["protocol"])
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ]))
}